module.exports = __webpack_public_path__ + "media/SetB_T3_A.f888b739.mp3";